import { render, staticRenderFns } from "./BankAccountDetail.vue?vue&type=template&id=636e85e4&scoped=true&"
import script from "./BankAccountDetail.vue?vue&type=script&lang=js&"
export * from "./BankAccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636e85e4",
  null
  
)

export default component.exports